// extracted by css-extract-rspack-plugin
export default {"avatar":"avatar--LgOWZWavy4VZRF_X","imageTable":"image-table--mGr1FaWIoAPq3rX8","artifact":"artifact--xa_a2vdGRwySdncn","corrupted":"corrupted--SYIC0WhQWLQQkqxG"};